<template>
  <div>
    <ul class="tags" style="list-style-type:none;margin: 0;padding: 0px">
      <template v-if="isDrag">
        <draggable
          v-model="vtags"
          class="dragarea"
          :options="{ handle: '.my-handle', filter: '.ignore-elements', animation: 150}"
        >
          <tag-item
            v-for="(tag,index) in vtags"
            :key="'tag_'+ index"
            class="item"
            :isDrag="isDrag"
            v-model="vtags[index].text"
            @onDelete="removeTag(index)"
            @onChange="updateTag(index,$event)"
            @tags-changed="$emit('tags-changed',vtags)"
          ></tag-item>

          <li
            style="display: inline-block;margin-bottom:3px; margin-right: 3px;"
            slot="footer"
            v-if="max == 0 || max > vtags.length"
          >
            <a
              ref="addTagBtn"
              href="javascript:void(0);"
              v-if="!isAdd"
              style="margin: 0px 0px;display:block"
              class="btn-tag"
              @click="onClickAddBtn"
            >
              <v-icon small>add</v-icon>
              {{btnText}}
            </a>
            <input
              v-else
              ref="addInput"
              type="text"
              @blur="addNewTag"
              @keyup.enter="addNewTag"
              v-model="newTag"
              :placeholder="placeholder"
            />
          </li>
        </draggable>
      </template>
      <template v-else>
        <tag-item
          v-for="(tag,index) in vtags"
          :key="'tag_'+ index"
          :isDrag="isDrag"
          class="item"
          v-model="vtags[index].text"
          @onDelete="removeTag(index)"
          @onChange="updateTag(index,$event)"
          @tags-changed="$emit('tags-changed',vtags)"
        ></tag-item>

        <li
          style="display: inline-block;margin-bottom:3px; margin-right: 3px;"
          slot="footer"
          v-if="max == 0 || max > vtags.length"
        >
          <a
            ref="addTagBtn"
            href="javascript:void(0);"
            v-if="!isAdd"
            style="margin: 0px 0px;display:block"
            class="btn-tag"
            @click="onClickAddBtn"
          >
            <v-icon small>add</v-icon>
            {{btnText}}
          </a>
          <input
            v-else
            ref="addInput"
            type="text"
            @blur="addNewTag"
            @keyup.enter="addNewTag"
            v-model="newTag"
            :placeholder="placeholder"
          />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import TagItem from './TagItem'
export default {
  props: {
    value: undefined,
    tags: undefined,
    edit: {
      type: Boolean,
      default: false
    },
    placeholder: 'Type Message',
    btnText: {
      default: 'Add'
    },
    max: {
      type: Number,
      default: 0
    },
    isDrag: {
      type: Boolean,
      default: true
    }
  },
  components: {
    draggable,
    TagItem
  },
  data: function() {
    return {
      isAdd: false,
      vtags: [],
      newTag: ''
    }
  },
  mounted: function() {
    if (this.tags) {
      this.vtags = this.tags
    }
  },
  methods: {
    onClickAddBtn: function() {
      var vm = this
      vm.isAdd = true
      vm.$nextTick(function() {
        vm.$refs.addInput.focus()
      })
    },
    pressEnter: function(e) {
      if (e.keyCode === 13) {
        this.addNewTag()
      }
    },
    addNewTag: function() {
      var vm = this
      if (vm.newTag.replace('​', '').trim() === '') {
        vm.newTag = ''
        vm.isAdd = false
        return false
      }
      var tags = vm.newTag.split(',')
      var isDuplicate = false
      $.each(tags, function(index, tag) {
        if (tag.replace('​', '').trim() != '') {
          if (vm.vtags && vm.vtags.map(t => t.text).indexOf(tag.trim()) !== -1) {
            isDuplicate = true
          } else {
            isDuplicate = false
          }
          vm.$emit(
            'before-adding-tag',
            Object.assign(
              {},
              {
                tag: {
                  // status: 'add',
                  text: tag.replace('​', '').trim(),
                  isDuplicate: isDuplicate
                },
                addTag: function(event) {
                  vm.vtags.push({ text: tag.replace('​', '') })
                  vm.$emit('tags-changed', vm.vtags)

                  vm.newTag = ''
                  vm.isAdd = false
                  vm.$nextTick(function() {
                    vm.$refs.addTagBtn.click()
                  })
                },
                error: function() {
                  vm.isError = true
                }
              }
            )
          )
        }
      })
    },
    removeTag: function(index) {
      this.vtags.splice(index, 1)
    },
    updateTag: function(index, payload) {
      // console.log(payload)
      var vm = this
      var isDuplicate = false
      // console.log(vm.vtags.map(t => t.text).indexOf(payload.tag.text.trim()),index)
      if (
        vm.vtags.map(t => t.text).indexOf(payload.tag.text.trim()) !== index &&
        vm.vtags.map(t => t.text).indexOf(payload.tag.text.trim()) !== -1
      ) {
        isDuplicate = true
      } else {
        isDuplicate = false
      }
      payload.tag.isDuplicate = isDuplicate
      vm.$emit('before-adding-tag', payload)
    }
  },
  watch: {
    tags: function() {
      if (this.tags) {
        this.vtags = this.tags
      }
    },
    vtags: function() {
      this.$emit('tags-changed', this.vtags)
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/Tags.vue